import { useQuery } from '@tanstack/react-query';
import { apiGetAchievements, apiGetLevelInfo, apiGetXpHistory } from '@/lib/api';
import { qk } from '@/lib/queryKeys';

export function useLevelInfo() {
  return useQuery({
    queryKey: qk.levelInfo(),
    queryFn: apiGetLevelInfo,
    // Level only changes after a session is logged; mutation handlers in
    // useLogSession invalidate this key, so we can hold it indefinitely.
    staleTime: Infinity,
  });
}

export function useAchievements(status: 'earned' | 'locked' | 'all' = 'all') {
  return useQuery({
    queryKey: qk.achievements(status),
    queryFn: () => apiGetAchievements({ status }).then((r) => r.items),
  });
}

export function useXpHistory() {
  return useQuery({
    queryKey: qk.xpHistory(),
    queryFn: () => apiGetXpHistory().then((r) => r.items),
  });
}
